import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { PropType } from "vue"
import { Theme } from "@/types"
import { THEMES } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'FormContainer',
  props: {
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
    required: true,
  },
  iconType: {
    type: String,
    default: "outline",
  },
  theme: {
    type: Object as PropType<Theme>,
    default: () => ({
      primaryColor: THEMES.PERALTA_PRIMARY,
      iconColor: THEMES.PERALTA_PRIMARY_RED,
    }),
    required: false,
  },
},
  setup(__props) {



return { __sfc: true,Icon }
}

})